/*
    SOURCES:
        city.png: http://www.freepngclipart.com/free-png/42010-blue-building-city-festival-mid-autumn-illustration-vector
        contractor.jpg: https://www.freeimages.com/photo/construction-1239313
        lonely-bulb.jpg: https://www.freeimages.com/photo/lonely-bulb-1532511
        light-bulb.jpg: https://www.freeimages.com/photo/light-bulb-1413578
        light-bulb-in-chalkboard: https://www.pexels.com/photo/black-and-white-blackboard-business-chalkboard-356043/
        city-hall-energy-consumption.jpg: https://www.pexels.com/photo/money-pink-coins-pig-9660/
        city-hall-team-management.jpg: https://www.pexels.com/photo/photo-of-group-of-people-in-a-meeting-1661004/
        city-hall-stock-management.jpg: https://www.pexels.com/photo/bright-bulbs-crowded-electric-light-383838/
        city-hall-demand-management.jpg: https://www.pexels.com/photo/flat-lay-photography-of-macbook-pro-beside-paper-1509428/
        communication.png: https://www.pngitem.com/middle/TRTJRJR_people-talking-cartoon-png-transparent-png/
 */

let origin = window.location.origin;
if(origin === "null") origin = document.getElementsByTagName("base")[0].getAttribute("href")
const imagesPath = origin + "/img";

const config = {
    origin: window.location.origin,
    baseUrl: document.getElementsByTagName("base")[0].getAttribute("href"),
    faviconsPath: "favicons",
    imagesPath,
    images: {
        geoluxLogo: imagesPath + "/geolux-logo.png",
        backgroundFeaturesDark: imagesPath + "/background-features-dark.png",
        lonelyBulb: imagesPath + "/lonely-bulb.jpg",
        lightBulb: imagesPath + "/light-bulb.jpg",
        lightBulbInChalkboard: imagesPath + "/light-bulb-in-chalkboard.jpg",
        lightingPointsMap: imagesPath + "/geolux-mapa-de-pontos.png",
        dashboard: imagesPath + "/geolux-dashboard.png",
        androidApp_1: imagesPath + "/geolux-android-app-1.png",
        androidApp_2: imagesPath + "/geolux-android-app-2.png",
        androidApp_3: imagesPath + "/geolux-android-app-3.png",
        city: imagesPath + "/city.png",
        contractor: imagesPath + "/contractor.png",
        communication: imagesPath + "/communication.png",
        attendant: imagesPath + "/attendant.png",
        selfServiceWebsite: imagesPath + "/self-service-website.jpg",
        selfServiceWebsiteSmall: imagesPath + "/self-service-website-small.jpg",
        earthLights: imagesPath + "/earth-lights.jpg",
        home: {
            carousel: {
                citizen: imagesPath + "/home-carousel-citizen.png",
                cityHall: imagesPath + "/home-carousel-city-hall.png",
                contractor: imagesPath + "/home-carousel-contractor.png",
                news: imagesPath + "/home-carousel-news.png",
            },
        },
        cityHall: {
            carousel: {
                map: imagesPath + "/city-hall-carousel-map.png",
                expenses: imagesPath + "/city-hall-carousel-expenses.png",
                averageTime: imagesPath + "/city-hall-carousel-average-time.png",
                warranty: imagesPath + "/city-hall-carousel-warranty.png",
                teamProductivity: imagesPath + "/city-hall-carousel-team-productivity.png",
            },
            energyConsumption: imagesPath + "/city-hall-energy-consumption.jpg",
            inFieldOperations: imagesPath + "/city-hall-in-field-operations.png",
            iluminationPark: imagesPath + "/city-hall-ilumination-park.png",
            teamManagement: imagesPath + "/city-hall-team-management.jpg",
            stockManagement: imagesPath + "/city-hall-stock-management.jpg",
            demandManagement: imagesPath + "/city-hall-demand-management.jpg",
        },
        facebookBot: {
            step_1: imagesPath + "/facebook-step-1.png",
            step_2: imagesPath + "/facebook-step-2.png",
            step_3: imagesPath + "/facebook-step-3.png",
        },
        telegramBot: {
            step_1: imagesPath + "/telegram-step-1.png",
            step_2: imagesPath + "/telegram-step-2.jpg",
            step_3: imagesPath + "/telegram-step-3.jpg",
            step_4: imagesPath + "/telegram-step-4.jpg",
            chatExample: imagesPath + "/telegram-chat-example.jpg",
        },
        icons: {
            facebook: imagesPath + "/facebook-icon.png",
            telegram: imagesPath + "/telegram-icon.svg",
        },
        news: {
            aracaju_1: imagesPath + "/noticia-aracaju-1.jpg",
            mogiDasCruzes_1: imagesPath + "/noticia-mogi-das-cruzes-1.jpg",
            mogiDasCruzes_2: imagesPath + "/noticia-mogi-das-cruzes-2.png",
            colombo_1: imagesPath + "/noticia-colombo-1.jpg",
            uniaoDaVitoria_1: imagesPath + "/noticia-uniao-da-vitoria-1.png",
            paranagua_1: imagesPath + "/noticia-paranagua-1.jpg",
            indaiatuba_1: imagesPath + "/noticia-indaiatuba-1.jpg",
            jandira_1: imagesPath + "/noticia-jandira-1.jpg",
        },
    },
    apkUrl: "https://site.geolux.com.br/mobile/geolux-android.apk",
}
export default config;